import { Outlet, useNavigate } from 'react-router-dom';
import Header from '@/components/ui/Header';
import {
	Building2,
	CalendarDays,
	FileText,
	FlaskConical,
	Gem,
	Headphones,
	Hospital,
	LayoutDashboard,
	MessageCircleQuestionMark,
	Newspaper,
	Package,
	Shield,
	Sparkles,
	Stethoscope,
	Users,
} from 'lucide-react';
import { Sidebar } from '@/components/ui';
import { useGetMeAdmin } from '@/services/queries/admin';
import { useEffect } from 'react';
import { useLogoutAdmin } from '@/services/mutations/admin';
import { SidebarProvider } from '@/context/SidebarContext';

const iconClass = 'h-[1.125rem] w-[1.125rem] text-stone-950';

const AdminLayout = () => {
	const navigate = useNavigate();
	const { data, isLoading } = useGetMeAdmin();

	const sidebarItems = [
		{
			type: 'section' as const,
			text: 'Visão Geral',
			path: '#visao-geral',
		},
		{
			icon: <LayoutDashboard className={iconClass} />,
			text: 'Dashboard',
			path: '/admin/dashboard',
		},

		{
			type: 'section' as const,
			text: 'Operação',
			path: '#operacao',
		},
		{
			icon: <CalendarDays className={iconClass} />,
			text: 'Consultas',
			path: '/admin/consultas',
		},
		{
			icon: <Stethoscope className={iconClass} />,
			text: 'Profissionais',
			path: '/admin/profissionais',
		},
		{
			icon: <Users className={iconClass} />,
			text: 'Usuários',
			path: '/admin/pacientes',
		},

		{
			type: 'section' as const,
			text: 'Recursos',
			path: '#recursos',
		},
		{
			icon: <Package className={iconClass} />,
			text: 'Serviços',
			path: '/admin/recursos',
		},
		{
			icon: <Gem className={iconClass} />,
			text: 'Clubes',
			path: '/admin/clubes',
		},
		{
			icon: <FileText className={iconClass} />,
			text: 'Formulários',
			path: '/admin/formularios',
		},
		{
			icon: <Sparkles className={iconClass} />,
			text: 'Match',
			path: '/admin/match',
		},

		{
			type: 'section' as const,
			text: 'Laboratório',
			path: '#laboratorio',
		},
		{
			icon: <FlaskConical className={iconClass} />,
			text: 'Sandbox',
			path: '/admin/sandbox',
		},

		{
			type: 'section' as const,
			text: 'Organizações',
			path: '#organizacoes',
		},
		{
			icon: <Building2 className={iconClass} />,
			text: 'Empresas',
			path: '/admin/empresas',
		},
		{
			icon: <Hospital className={iconClass} />,
			text: 'Clínicas',
			path: '/admin/clinicas',
		},

		{
			type: 'section' as const,
			text: 'Acesso',
			path: '#acesso',
		},
		{
			icon: <Shield className={iconClass} />,
			text: 'Admin',
			path: '/admin/admins',
		},
		{
			icon: <Headphones className={iconClass} />,
			text: 'Suporte',
			path: '/admin/suporte',
		},

		{
			type: 'section' as const,
			text: 'Conteúdo',
			path: '#conteudo',
		},
		{
			icon: <Newspaper className={iconClass} />,
			text: 'Artigos',
			path: '/admin/blog',
		},
		{
			icon: <MessageCircleQuestionMark className={iconClass} />,
			text: 'Q&A',
			path: '/admin/faq',
		},
	];

	const { mutate } = useLogoutAdmin(() => navigate('/admin/login'));

	useEffect(() => {
		if (!isLoading) {
			if (!data || !data.active) {
				navigate('/admin/login');
			}
		}
	}, [isLoading, data, navigate]);

	if (!data) {
		return null;
	}

	return (
		<SidebarProvider items={sidebarItems} onLogout={mutate} compact>
			<section className="flex min-h-screen w-full flex-col overflow-x-hidden bg-zinc-50">
				{!isLoading && data && (
					<>
						<Header />
						<main className="flex min-h-0 w-full flex-1">
							<Sidebar />
							<section className="z-0 min-h-0 w-full flex-1 overflow-y-auto md:px-4">
								<Outlet />
							</section>
						</main>
					</>
				)}
			</section>
		</SidebarProvider>
	);
};

export default AdminLayout;
